/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import "./Effectivity.css";
import EffectivityForm from "./EffectivityForm";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { getAllActive } from "../../../backend/read/GetAllActive";

const EditEffectivity = () => {
    const { state } = useLocation();
    const [activeParts, setActiveParts] = useState(0);
    const effectivity = state || { EFFECTIVITY_ID: '', ACTIVE_FLAG: '', LAST_UPDATED_DATE: '' };
    effectivity.EFFECTIVITY_ID && getAllActive("PARTS").then((partsData)=>{
        let parts = JSON.parse(partsData.body.data).Items;
        parts && setActiveParts(parts.filter((part)=>{return part.EFFECTIVITY_ID===effectivity.EFFECTIVITY_ID;}).length);
    });
    return (<EffectivityForm id= {effectivity.EFFECTIVITY_ID} effectivityStatus={effectivity.ACTIVE_FLAG.toLowerCase()} 
                                        effectivityValue={effectivity.EFFECTIVITY_ID} activePartsCount={activeParts} mode = {"update"} />);
};

export default EditEffectivity;
